import { connect } from 'react-redux';
import { formValueSelector } from 'gandi.react-form';
import AddressField from './components/AddressField';
export const mapStateToProps = (state, ownProps) => ({
  countryFieldValue: formValueSelector(ownProps.form)(state, 'country')
});
export default connect(mapStateToProps)(AddressField);